// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/system.js#1 $
'use strict';

/**
* @ngdoc overview
* @name tcApp
* @description
* # tcApp
*
* Main module of the TrakCare Angular application.
*/

angular.module('tc', [
	'tc.templates',
	'tc.position',
	'tc.lookup',
	'tc.legacyScope',
	'tc.global',
	'tc.date',
	'tc.validate',
	'tc.time',
	'tc.tools',
	'tc.iconProfile',
	'tc.dateParser',
	'tc.stickyheader',
	'tc.shortcutkey',
	'tc.accordion',
	'tc.menu',
	'tc.confirmUnload',
	'tc.tkLib',
	'tc.anchor',
	'tc.chips',
	'tc.quickDelete',
	'tc.performance',
	'tc.longTextOverflow',
	]);

angular.module('tcApp', [
	'ngRoute',
	'ngAria',
	'ngAnimate',
	'ngMessages',
	'ngMaterial',
	'ngSanitize',
	'angular-loading-bar',
	'duScroll',
	'tc',
	'oc.lazyLoad',
]);
